module.exports = __webpack_public_path__ + "static/media/pod_active.de427fd1.svg";